import React from 'react';
import { Modal, Button, Space } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import { useVersionCheck } from '../hooks/useVersionCheck';

const UpdateBanner: React.FC = () => {
  const { updateAvailable, dismiss } = useVersionCheck();

  return (
    <Modal
      open={updateAvailable}
      onCancel={dismiss}
      closable
      maskClosable={false}
      footer={
        <Space>
          <Button onClick={dismiss}>Schließen</Button>
          <Button
            type="primary"
            icon={<SyncOutlined />}
            onClick={() => { dismiss(); window.location.reload(); }}
          >
            Neu laden
          </Button>
        </Space>
      }
      title={
        <Space>
          <SyncOutlined style={{ color: '#1890ff' }} />
          Neue Version verfügbar
        </Space>
      }
      width={420}
    >
      <p style={{ margin: 0 }}>
        Eine neue Version der Anwendung wurde bereitgestellt.<br />
        Bitte laden Sie die Seite neu, um die aktuellste Version zu verwenden.
      </p>
    </Modal>
  );
};

export default UpdateBanner;
